import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import PaymentMethodChannelForm from './PaymentMethodChannelForm';

import CRMApi from 'Api/CRM/CRMApi';
import SweetAlert from 'crm/elements/alerts/SweetAlert';
import Card from 'crm/elements/common/Card';
import handleValidationErrors from 'crm/helpers/ResponseErrorHelper';

function PaymentMethodChannelEdit() {
    const { id } = useParams();
    const [paymentMethodChannel, setPaymentMethodChannel] = useState([]);
    const [errors, setErrors] = useState({});
    const history = useHistory();
    const url = `payment_method_channel/${id}`;

    useEffect(() => {
        CRMApi.get(url).then((response) => setPaymentMethodChannel(response.data));
    }, []);

    const handleEditPaymentMethodChannel = async (updatePaymentMethodChannel) => {
        const formData = new FormData();
        Object.entries(updatePaymentMethodChannel).forEach(([key, value]) => {
            if (value && key !== 'logo_url') {
                formData.append(key, value);
            }
        });
        formData.append('_method', 'patch');

        try {
            await CRMApi.post(url, formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data',
                },
            });
            await SweetAlert.success('Payment Method channel updated correctly.');
            history.push('/payment_method_channels');
        } catch (error) {
            handleValidationErrors(error, setErrors);
        }
    };

    return (
        <Card title="Update Payment Method Channel">
            <PaymentMethodChannelForm
                action={handleEditPaymentMethodChannel}
                errors={errors}
                paymentMethodChannelData={paymentMethodChannel}
            />
        </Card>
    );
}
export default PaymentMethodChannelEdit;
